import * as CONSTANTS from '../shared/constants';

const { CANVAS_WIDTH, CANVAS_HEIGHT } = CONSTANTS;

// Utility functions for rendering game over screen
export const renderGameOverScreen = (
  ctx,
  winner,
  gameOverCountdown,
  players,
  characterSprites,
  characterSpriteSVGs,
  coloredSpritesCache,
  createColoredSprite
) => {
  // Dark overlay
  ctx.fillStyle = 'rgba(0, 0, 0, 0.7)';
  ctx.fillRect(0, 0, CANVAS_WIDTH, CANVAS_HEIGHT);
  
  if (winner !== null) {
    const winningPlayer = players.get(winner);
    if (winningPlayer) {
      renderWinnerSprite(ctx, winningPlayer, winner, gameOverCountdown, characterSprites, characterSpriteSVGs, coloredSpritesCache, createColoredSprite);
    }
  } else {
    renderDraw(ctx, gameOverCountdown);
  }
};

const renderWinnerSprite = (ctx, winningPlayer, winner, gameOverCountdown, characterSprites, characterSpriteSVGs, coloredSpritesCache, createColoredSprite) => {
  const spriteSize = 120;
  const spriteX = CANVAS_WIDTH / 2 - spriteSize / 2;
  const spriteY = CANVAS_HEIGHT / 2 - 150;
  const spriteBottomY = spriteY + (spriteSize * 1.5);
  
  if (characterSpriteSVGs && characterSpriteSVGs.front && characterSpriteSVGs.front[0]) {
    const cacheKey = `${winningPlayer.color}-front-0`;
    let sprite = coloredSpritesCache.current.get(cacheKey);
    
    if (!sprite) {
      const svgText = characterSpriteSVGs.front[0];
      sprite = createColoredSprite(svgText, winningPlayer.color);
      if (sprite) {
        coloredSpritesCache.current.set(cacheKey, sprite);
      } else {
        sprite = characterSprites.front && characterSprites.front[0];
      }
    }
    
    if (sprite && sprite.complete) {
      ctx.drawImage(sprite, spriteX, spriteY, spriteSize, spriteSize * 1.5);
    } else if (sprite) {
      if (characterSprites.front?.[0]) {
        ctx.drawImage(characterSprites.front[0], spriteX, spriteY, spriteSize, spriteSize * 1.5);
      }
    }
    
    // Add colored glow effect
    ctx.shadowColor = winningPlayer.color;
    ctx.shadowBlur = 20;
    ctx.strokeStyle = winningPlayer.color;
    ctx.lineWidth = 4;
    ctx.strokeRect(spriteX - 2, spriteY - 2, spriteSize + 4, (spriteSize * 1.5) + 4);
    ctx.shadowBlur = 0;
  } else if (characterSprites.front?.[0]) {
    ctx.drawImage(characterSprites.front[0], spriteX, spriteY, spriteSize, spriteSize * 1.5);
    
    ctx.shadowColor = winningPlayer.color;
    ctx.shadowBlur = 20;
    ctx.strokeStyle = winningPlayer.color;
    ctx.lineWidth = 4;
    ctx.strokeRect(spriteX - 2, spriteY - 2, spriteSize + 4, (spriteSize * 1.5) + 4);
    ctx.shadowBlur = 0;
  } else {
    // Fallback to colored circle
    const circleY = spriteY + 90;
    ctx.fillStyle = winningPlayer.color;
    ctx.beginPath();
    ctx.arc(CANVAS_WIDTH / 2, circleY, 50, 0, 2 * Math.PI);
    ctx.fill();
    
    ctx.fillStyle = '#fff';
    ctx.font = 'bold 32px Arial';
    ctx.textAlign = 'center';
    ctx.fillText(`P${winner + 1}`, CANVAS_WIDTH / 2, circleY + 8);
  }
  
  // Winner text
  ctx.fillStyle = '#fff';
  ctx.font = '32px Arial';
  ctx.textAlign = 'center';
  const winnerName = winningPlayer.nickname || `Player ${winner + 1}`;
  ctx.fillText(`${winnerName} Wins!`, CANVAS_WIDTH / 2, spriteBottomY + 30);
  
  ctx.font = '18px Arial';
  ctx.fillText(`Returning to lobby in ${gameOverCountdown}...`, CANVAS_WIDTH / 2, spriteBottomY + 70);
};

const renderDraw = (ctx, gameOverCountdown) => {
  ctx.fillStyle = '#fff';
  ctx.font = '32px Arial';
  ctx.textAlign = 'center';
  ctx.fillText('Draw!', CANVAS_WIDTH / 2, CANVAS_HEIGHT / 2 + 40);
  
  ctx.font = '18px Arial';
  ctx.fillText(`Returning to lobby in ${gameOverCountdown}...`, CANVAS_WIDTH / 2, CANVAS_HEIGHT / 2 + 80);
};

// Keep the component for consistency but it doesn't render anything
const GameOverScreen = () => {
  return null;
};

export default GameOverScreen;